import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { environment } from 'environment';
import { Language } from '@constants/supportedLanguages';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { i18nHashes } from '@airwallet/translate/utils';

@Injectable()
export class VersionedHttpLoader implements TranslateLoader {
    private prefix = './assets/i18n/';
    private suffix = '.json';
    constructor(private http: HttpClient) {}
    /**
     * @param lang string
     * @returns http get for a versioned or hashed version of the file (fallsback to app version if no hash found)
     * @description Uses {@link i18nHashes} to get the hash for the specific language file.
     */
    public getTranslation(lang: string): Observable<any> {
        const hashOrVersion = i18nHashes[lang as keyof typeof i18nHashes] || environment.VERSION || '1.0.0';

        const baseFileUrl = `${this.prefix}${lang}${this.suffix}`;

        const versionedUrl = `${baseFileUrl}?v=${hashOrVersion}`;
        return this.http.get(versionedUrl);
    }
}
export function appInitializerFactory(translate: TranslateService, localStorageService: LocalStorageService) {
    return async () => {
        translate.setDefaultLang('en');
        const lang: Language | null | undefined = localStorageService.getItem('language');

        let langCode = 'en'; // Default
        const browserLang = window.navigator.language.substring(0, 2);

        if (lang) {
            langCode = lang.language_code;
        } else if (browserLang === 'nb' || browserLang === 'nn') {
            langCode = 'no';
        } else if (['en', 'da', 'fr', 'de', 'es', 'it', 'no', 'pl'].includes(browserLang)) {
            langCode = browserLang;
        }

        try {
            // This now pulls from your local Map via StaticTranslateLoader
            await firstValueFrom(translate.use(langCode));
        } catch (error) {
            console.error(`Error loading translations for ${langCode}, falling back to 'en'`, error);
            await firstValueFrom(translate.use('en'));
        }
    };
}
